function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPeopleCloseAccountRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24 18a6 6 0 100 12 6 6 0 000-12zm0 10a3.996 3.996 0 01-3.858-3h7.716A3.996 3.996 0 0124 28zm-3.858-5a3.981 3.981 0 017.716 0h-7.716z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 24a7.994 7.994 0 013.77-6.778 35.69 35.69 0 00-2.624-1.61.989.989 0 01-.23-1.547C18.306 12.583 19 11.332 19 8a5.763 5.763 0 00-6.002-6A5.763 5.763 0 007 8c0 3.333.695 4.583 2.083 6.065a.988.988 0 01-.23 1.547A24.279 24.279 0 004 19c-1.675 1.675-1.947 5.456-1.991 8.991A1.985 1.985 0 003.996 30h14.73A7.978 7.978 0 0116 24z",
    fill: props.color
  }));
}

export default SvgIconPeopleCloseAccountRexFilled;